export default __webpack_public_path__ + "static/media/video.363474f1.svg";